import { render, staticRenderFns } from "./AutomatorControls.vue?vue&type=template&id=c8b94a66&scoped=true&"
import script from "./AutomatorControls.vue?vue&type=script&lang=js&"
export * from "./AutomatorControls.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorControls.vue?vue&type=style&index=0&id=c8b94a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b94a66",
  null
  
)

export default component.exports